import { AgentThreadMessage } from "@/store/chat.types";

/**
 * 判断是否为用户消息
 */
export function isUserMessage(message: AgentThreadMessage): boolean {
  return message.type === "user";
}

export function isAssistantTextMessage(message: AgentThreadMessage): boolean {
  return message.type === "assistant" && !message.content?.func_name;
}

export function isToolRequestMessage(message: AgentThreadMessage): boolean {
  return message.type === "assistant" && !!message.content?.func_name;
}

export function isToolResponseMessage(message: AgentThreadMessage): boolean {
  return message.type === "function";
}

export function isToolMessage(message: AgentThreadMessage): boolean {
  return isToolRequestMessage(message) || isToolResponseMessage(message);
}

export function isAssistMessage(message: AgentThreadMessage): boolean {
  return isAssistantTextMessage(message) || isToolMessage(message);
}
